import script from "./BuddyListCurrentCall.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuddyListCurrentCall.vue?vue&type=script&setup=true&lang=ts"

import "./BuddyListCurrentCall.vue?vue&type=style&index=0&id=4786651c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4786651c"]])

export default __exports__